import { render, staticRenderFns } from "./TalkRoom.vue?vue&type=template&id=0ad1ae23"
import script from "./TalkRoom.vue?vue&type=script&lang=js"
export * from "./TalkRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports